import { URL_SEGMENT_LOCALES } from '@redbubble/next-i18n';

export const getUrlWithLocale = (locale: string, url?: string | null) => {
  const localePrefix = URL_SEGMENT_LOCALES[locale] || URL_SEGMENT_LOCALES.en;
  return `${localePrefix}${url}`;
};
